export const HORIZONTAL = 'HORIZONTAL';
export const VERTICAL = 'VERTICAL';
export const XY = 'XY';
export const LEFT = 'LEFT';
export const RIGHT = 'RIGHT';
export const NORTH = 'NORTH';
export const SOUTH = 'SOUTH';
export const EAST = 'EAST';
export const WEST = 'WEST';
